import { ItemLabelModel } from '../../../../shared/components/dropdown/models/dropdown-props.model';
import { FileMetadataModel } from '../../../../shared/models/file-metadata.model';
import { IdFile } from '../../../../shared/models/id-file.model';
import {
  mapFileMetadataModelToIdFile,
  mapPlatformModelToItemLabelModel,
  mapStatesEnumToItemLabelModel,
} from '../../../../shared/utils/mapping/mapping.utils';
import { ReleaseModel } from '../../../models/release.model';
import { ReleasesFormikModel } from '../models/releases-formik.model';

export const getReleasesFormValues = (
  appsFiles?: FileMetadataModel[],
  data?: ReleaseModel
): Partial<ReleasesFormikModel> => {
  const mappedPlatforms: ItemLabelModel[] | undefined =
    appsFiles &&
    appsFiles
      .map(item =>
        item && item.platforms
          ? item.platforms.map(mapPlatformModelToItemLabelModel)
          : []
      )
      .flatMap(item => item);

  const defaultApks: IdFile[] | undefined = appsFiles?.map(
    mapFileMetadataModelToIdFile
  );

  const sizeInBytes = appsFiles?.reduce(
    (acc, item) => acc + item.sizeInBytes,
    0
  );

  const version =
    appsFiles?.find(app => app.versionName !== null)?.versionName || '';

  const versionCode =
    appsFiles?.find(app => app.versionCode !== null)?.versionCode || 0;

  return {
    version: version,
    versionCode: versionCode,
    sizeInBytes: sizeInBytes,
    platforms: mappedPlatforms,
    description: data?.description ?? '',
    status: data ? mapStatesEnumToItemLabelModel(data.status) : null,
    defaultApkFiles: defaultApks,
  };
};
